import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { mediciAPI } from '../services/api';
import '../styles/AlertScadenzeMedici.css';

const STORAGE_KEY_PREFIX = 'rimedichub_scadenze_popup_lastSeen_';

const AlertScadenzeMedici = ({ user }) => {
  const navigate = useNavigate();
  const [scadenze, setScadenze] = useState([]);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Solo per admin
    if (!user || user.ruolo !== 'admin') return;

    const userId = user.id;
    const storageKey = `${STORAGE_KEY_PREFIX}${userId}`;
    const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
    const lastSeen = localStorage.getItem(storageKey);

    // Già mostrato oggi: skip
    if (lastSeen === today) return;

    const checkScadenze = async () => {
      try {
        const response = await mediciAPI.getScadenze();
        if (response.data.success) {
          const list = response.data.data.medici || [];
          if (list.length > 0) {
            setScadenze(list);
            setShow(true);
          }
        }
      } catch (err) {
        console.error('Errore controllo scadenze assicurazioni:', err);
      }
    };

    checkScadenze();
  }, [user]);

  const markAsSeen = () => {
    if (user?.id) {
      const today = new Date().toISOString().split('T')[0];
      localStorage.setItem(`${STORAGE_KEY_PREFIX}${user.id}`, today);
    }
  };

  const handleClose = () => {
    markAsSeen();
    setShow(false);
  };

  const handleGoToMedici = () => {
    markAsSeen();
    setShow(false);
    navigate('/medici');
  };

  const getScadenzaStatus = (dataScadenza) => {
    if (!dataScadenza) return null;
    const oggi = new Date();
    oggi.setHours(0, 0, 0, 0);
    const scadenza = new Date(dataScadenza);
    const diffGiorni = Math.ceil((scadenza - oggi) / (1000 * 60 * 60 * 24));

    if (diffGiorni < 0) return { tipo: 'scaduta', label: 'Scaduta', giorni: diffGiorni };
    if (diffGiorni <= 30) return { tipo: 'critica', label: `${diffGiorni} gg`, giorni: diffGiorni };
    if (diffGiorni <= 60) return { tipo: 'attenzione', label: `${diffGiorni} gg`, giorni: diffGiorni };
    return null;
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('it-IT');
  };

  // Conteggi per il riepilogo
  const counts = scadenze.reduce(
    (acc, s) => {
      const st = getScadenzaStatus(s.assicurazione_data_scadenza);
      if (st?.tipo === 'scaduta') acc.scadute++;
      else if (st?.tipo === 'critica') acc.critiche++;
      else if (st?.tipo === 'attenzione') acc.attenzione++;
      return acc;
    },
    { scadute: 0, critiche: 0, attenzione: 0 }
  );

  if (!show || scadenze.length === 0) return null;

  return (
    <div className="alert-popup-overlay" onClick={handleClose}>
      <div className="alert-popup-content" onClick={(e) => e.stopPropagation()}>
        <div className="alert-popup-header">
          <div className="alert-popup-icon"></div>
          <h2>Assicurazioni in scadenza</h2>
          <button className="alert-popup-close" onClick={handleClose} aria-label="Chiudi">
            ✕
          </button>
        </div>

        <div className="alert-popup-body">
          <p className="alert-popup-summary">
            {scadenze.length === 1
              ? 'Un medico ha la polizza assicurativa in scadenza o già scaduta:'
              : `${scadenze.length} medici hanno la polizza assicurativa in scadenza o già scaduta:`}
          </p>

          {/* Badge riepilogo */}
          <div className="alert-popup-counts">
            {counts.scadute > 0 && (
              <span className="count-badge count-scaduta">
                {counts.scadute} scadut{counts.scadute === 1 ? 'a' : 'e'}
              </span>
            )}
            {counts.critiche > 0 && (
              <span className="count-badge count-critica">
                {counts.critiche} entro 30 giorni
              </span>
            )}
            {counts.attenzione > 0 && (
              <span className="count-badge count-attenzione">
                {counts.attenzione} entro 60 giorni
              </span>
            )}
          </div>

          {/* Lista dettagliata */}
          <ul className="alert-popup-list">
            {scadenze.map((s) => {
              const status = getScadenzaStatus(s.assicurazione_data_scadenza);
              return (
                <li key={s.id} className={`alert-popup-item ${status?.tipo || ''}`}>
                  <div className="alert-popup-item-main">
                    <strong>Dr. {s.cognome} {s.nome}</strong>
                    {s.assicurazione_compagnia && (
                      <span className="alert-popup-compagnia"> — {s.assicurazione_compagnia}</span>
                    )}
                  </div>
                  <div className="alert-popup-item-meta">
                    <span>Scadenza: <strong>{formatDate(s.assicurazione_data_scadenza)}</strong></span>
                    {status && (
                      <span className={`alert-popup-badge badge-${status.tipo}`}>
                        {status.label}
                      </span>
                    )}
                  </div>
                </li>
              );
            })}
          </ul>
        </div>

        <div className="alert-popup-footer">
          <button className="btn-secondary" onClick={handleClose}>
            Ho capito
          </button>
          <button className="btn-primary" onClick={handleGoToMedici}>
            Vai a Gestione medici
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertScadenzeMedici;
